import React, { FC } from 'react'
import { ErrorProps } from './'
import { useLocalization } from '@components/Localization'
import { Box, Text } from '@gassan-ui'
import * as S from './elements'
import { rem } from 'polished'
const Error: FC<ErrorProps> = ({ label }) => {
  const { messages } = useLocalization()
  // If passed a user-error code, e.g. user-error:invalid-voucher-code then use that code to translate it
  const message = label.includes('user-error')
    ? messages.notifications[label.replace('[GraphQL] ', '')] ||
      messages.notifications.refreshAndTryAgain
    : label
  return (
    <Box
      display="grid"
      gridTemplateColumns={[`100%`, `${rem(56)} auto`]}
      gridColumnGap={['.75rem', '1rem']}
      alignItems="center"
    >
      <Box display={['none', 'block']}>
        <S.ErrorIcon icon="exclamation"></S.ErrorIcon>
      </Box>
      <Box>
        <Text variant="micro" as="div" mb={[1, rem(3)]} color="error">
          {messages.notifications.somethingWentWrong}
        </Text>
        <Text as="div" color="error" mb={0} fontWeight="bold">
          {message}
        </Text>
      </Box>
    </Box>
  )
}

export default Error
